import { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import ExportComponent from '../../components/common/ExportComponent';
import FilterDateComponent from '../../components/common/FilterDateComponent';
import SingleView from '../../components/common/SingleView';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import { LIMIT } from '../../domain/constant';
import {
  LINK_URL,
  PAGE_SINGLE_TITLE,
  PAGE_TITLE,
  SIDEBAR_OPTIONS,
  inputFields,
} from '../../shared/enums/bills_enum';
import {
  useAllBills,
  useGetDropdownOptions,
  useUpdateBill,
} from '../../shared/hooks/UseBill';
import { UseDataForExcel, UseFilter } from '../../shared/hooks/UseExcel';
import EnhancedBillsSection from './_components/Table-View';

const AllBills = () => {
  const [data, setPageNumber, deleteBtnClicked, reloadData, setReloadData] =
    useAllBills();
  const [updateData] = useUpdateBill();
  const {
    bills_loading,
    bills,
    total_bills,
    page,
    pages,
    total_paid,
    total_not_paid,
  } = data;

  // const [totalAmount, setTotalAmount] = useState(0);
  const [dropdownOptions] = useGetDropdownOptions();

  // Load options for async select fields in sidebar
  const loadOptions = async (inputValue, callback, field) => {
    // Return the appropriate dropdown options based on the field
    if (field === 'client' && dropdownOptions.client) {
      callback(dropdownOptions.client);
    }
    if (field === 'package' && dropdownOptions.package) {
      callback(dropdownOptions.package);
    }
    if (field === 'collected_by' && dropdownOptions.collected_by) {
      callback(dropdownOptions.collected_by);
    }
    if (field === 'bank_account' && dropdownOptions.bank_account) {
      callback(dropdownOptions.bank_account);
    }
    if (field === 'review_status' && dropdownOptions.review_status) {
      callback(dropdownOptions.review_status);
    }
  };

  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  const [loadingActivityStatus, setLoadingActivityStatus] = useState(false);

  // Totals now come directly from backend (correct across all filtered pages)
  const total_amount_paid = total_paid || 0;
  const total_amount_not_paid = total_not_paid || 0;

  const updateStatus = async (id, status) => {
    if (id && status) {
      setLoadingActivityStatus(true);
      const newForm = new FormData();
      newForm.append('values', JSON.stringify(status));
      await updateData(id, newForm);
      await setReloadData(true);
      setLoadingActivityStatus(false);
    } else {
    }
  };
  useEffect(() => {
    if (dropdownOptions) {
      const statusArray = ['PAID', 'NOT PAID', 'CANCELLED'];
      const newStatusArray = statusArray.map((item) => {
        return {
          label: item,
          value: item,
        };
      });
      dropdownOptions.status = newStatusArray;
    }
  }, [dropdownOptions]);

  const [exportXLSXData] = UseFilter();

  const [convertToReadable, exportData] = UseDataForExcel();

  useEffect(() => {
    if (bills) {
      convertToReadable(bills, inputFields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bills]);

  const handleOnExport = () => {
    exportXLSXData(exportData, 'Bills', 'bills');
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_TITLE}
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink={PAGE_TITLE}
        />
        <ExportComponent handleOnExport={handleOnExport} />
        <FilterDateComponent link="/bills" />

        <div>
          <EnhancedBillsSection
            SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
            dropdownOptions={dropdownOptions}
            total_bills={total_bills}
            total_amount_paid={total_amount_paid}
            total_amount_not_paid={total_amount_not_paid}
            bills_loading={bills_loading}
            bills={bills}
            page={page}
            pages={pages}
            setPageNumber={setPageNumber}
            LIMIT={LIMIT}
            updateStatus={updateStatus}
            deleteBtnClicked={deleteBtnClicked}
            setModal={setModal}
            setModalData={setModalData}
            loadingActivityStatus={loadingActivityStatus}
            reloadData={reloadData}
            loadOptions={loadOptions}
            LINK_URL={'/bills/add'}
            PAGE_SINGLE_TITLE={''}
          />
        </div>
      </div>
      <ReactModal
        isOpen={modal}
        contentLabel="Modal"
        className="Modal"
        overlayClassName="Overlay"
        onRequestClose={() => {
          setModal(false);
        }}
      >
        <div className="quick-view">
          <div className="qv-header">
            <div className="title"> {PAGE_SINGLE_TITLE} </div>
            <div>
              <button
                onClick={() => {
                  setModal(false);
                }}
                className="btn btn-primary"
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
          {modalData && (
            <div className="qv-body">
              <SingleView
                data={modalData}
                inputFields={inputFields}
                label={PAGE_SINGLE_TITLE}
                link={LINK_URL}
                id={modalData._id}
                hideAllBtn={true}
                col={12}
              />
            </div>
          )}
        </div>
      </ReactModal>
    </div>
  );
};

export default AllBills;
